import StyledSecondaryButton from "../styledSecondaryButton.styled";

const bookAppointmentButtonHref: string =
  "https://www.wbstraining.de/beratungstermin-vereinbaren/?itm_source=userlike&itm_medium=hotlink&itm_campaign=terminbuchung";

const BookAppointmentButton = (): React.JSX.Element => {
  const handleClick = () => {
    const win = window.open(bookAppointmentButtonHref, "_blank");
    if (win) {
      win.opener = null;
    }
  };

  return (
    <StyledSecondaryButton onClick={handleClick}>
      Beratungstermin buchen
    </StyledSecondaryButton>
  );
};

export default BookAppointmentButton;
